import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetCommittedTransactionVolumeMutationVariables = Types.Exact<{
  input: Types.SetCommittedTransactionVolumeInput;
}>;


export type SetCommittedTransactionVolumeMutation = { __typename?: 'Mutation', setCommittedTransactionVolume: { __typename?: 'CommittedTransactionVolume', id: string, store_uuid: string, committed_volume: number, discount_per_transaction_in_cents: number } };


export const SetCommittedTransactionVolumeDocument = gql`
    mutation setCommittedTransactionVolume($input: SetCommittedTransactionVolumeInput!) {
  setCommittedTransactionVolume(input: $input) {
    id
    store_uuid
    committed_volume
    discount_per_transaction_in_cents
  }
}
    `;
export type SetCommittedTransactionVolumeMutationFn = Apollo.MutationFunction<SetCommittedTransactionVolumeMutation, SetCommittedTransactionVolumeMutationVariables>;

/**
 * __useSetCommittedTransactionVolumeMutation__
 *
 * To run a mutation, you first call `useSetCommittedTransactionVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCommittedTransactionVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCommittedTransactionVolumeMutation, { data, loading, error }] = useSetCommittedTransactionVolumeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCommittedTransactionVolumeMutation(baseOptions?: Apollo.MutationHookOptions<SetCommittedTransactionVolumeMutation, SetCommittedTransactionVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCommittedTransactionVolumeMutation, SetCommittedTransactionVolumeMutationVariables>(SetCommittedTransactionVolumeDocument, options);
      }
export type SetCommittedTransactionVolumeMutationHookResult = ReturnType<typeof useSetCommittedTransactionVolumeMutation>;
export type SetCommittedTransactionVolumeMutationResult = Apollo.MutationResult<SetCommittedTransactionVolumeMutation>;
export type SetCommittedTransactionVolumeMutationOptions = Apollo.BaseMutationOptions<SetCommittedTransactionVolumeMutation, SetCommittedTransactionVolumeMutationVariables>;